import { createFetcher } from '../contexts/Fetcher';
import { useContext } from 'react';
import { OrganizationContext } from '../contexts/OrganizationContext';
import { apiLicense } from '../resources/api/apiLicense';

const { useGetUnassignedLicenses } = apiLicense;

export const UnassignedLicensesFetcher = createFetcher(() => {
  const { organization } = useContext(OrganizationContext);
  return useGetUnassignedLicenses(organization ?? void 0).execute;
});
